module.exports = __webpack_public_path__ + "img/home_2.8dafd1d2.png";